module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-6a166fb3ab8d1414c6d3b5b14e5a3446.webp";